export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9746_TABLE_EDITOR_ADMINISTRATION': 'Table Editor Administration',
    '_9747_TABLE_SELECTION': 'Table Selection',
    '_9748_TABLE_INFORMATION_FOR_': 'Table Information for:',
    '_9749_TABLE': 'Table',
    '_9301_DESCRIPTION': 'Description',
    '_9479_CONFIRMATION': 'Confirmation',
    '_671_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ENTRY_': 'Are you sure you want to delete this entry?',
    '_9297_YES': 'Yes',
    '_9298_NO': 'No',
    '_9750_ENTRY_CREATED': 'Entry created',
    '_9751_FAILED_TO_CREATE_ENTRY': 'Failed to create entry',
    '_9752_ENTRY_DELETED': 'Entry deleted',
    '_9753_FAILED_TO_DELETE_ENTRY': 'Failed to delete entry'
};
